import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { serializeClasses } from 'utilities/css';

export const StyledContainer = styled.div`
  font-size: 14px;
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.panel.main.foreground};
  &.disabled {
    color: grey;
  }
`;

export const DescriptionText = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text03};
  margin-right: 8px;
`;

export const InfoText = ({
  disabled, text, className, ...rest
}) => {
  const classes = serializeClasses([className, disabled && 'disabled']);
  return (
    <StyledContainer className={classes} {...rest}>
      {text}
    </StyledContainer>
  );
};

InfoText.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  text: PropTypes.node,
};

InfoText.defaultProps = {
  className: undefined,
  disabled: false,
  text: undefined,
};

export const ErrorText = styled(InfoText)`
  white-space: pre-wrap;
  color: ${({ theme }) => theme.colors.errorRed01};
`;

export const SuccessText = styled(InfoText)`
  color: ${({ theme }) => theme.colors.acceptedGreen};
`;

export const HintText = styled(InfoText)`
  color: ${({ theme }) => theme.colors.accentGray05};
  font-weight: normal;
`;

export default InfoText;
